// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Z3fK","large":"styles_large__3PCc8"};